import { Component, useContext } from 'react';
import { Redirect } from 'react-router';
import { Container } from 'reactstrap';
import { AuthenticationContext, authenticationStates } from '../../msal/AuthenticationContext';
import { AuthorizationContext, authorizationStates } from '../../context/AuthorizationContext';
import { TenantContext } from '../../context/TenantContext';
import { Spinner } from '../../components/Spinner';

// This component is the landing page from the redirect back from the Azure AD authentication.
class PostLoginInternal extends Component {

    render() {
        const authenticationState = this.props.authenticationContext.getAuthenticationState();
        
        console.log(`[PostLogin, render] Start of rendering. Authenticationstate: '${authenticationState}'`);

        if (authenticationState === authenticationStates.AUTHENTICATING) {
            console.log("[PostLogin] Authentication process in progress, showing spinner");
            return <Container><Spinner/></Container> 
        }

        if (authenticationState === authenticationStates.NOT_AUTHENTICATED) {
            console.log("[PostLogin] Context is not authenticated, redirecting to home...");

            // The user entered this location not from a redirect from the login process (the user should either be authenticated 
            // or an authentication error should have occurred.               
            return <Redirect to='/'/>
        }

        // If tenants have been loaded but the list is empty, redirect to create a tenant
        if (this.props.tenantContext.hasLoadedTenants && this.props.tenantContext.availableTenants.length === 0) {
            console.log("[PostLogin] No tenants available.");
            return <Redirect to='/'/>
        }

        if (this.props.authorizationContext.authorizationState === authorizationStates.UNKNOWN ||
            this.props.authorizationContext.authorizationState === authorizationStates.CHECKING) {
            console.log("[PostLogin] Authorization state is unknown or checking, showing spinner.");

            // Directly after a redirect from a successful authentication, it is not known immediately if the tenant of the user 
            // is authorized (has been signed up) to use this application. This is checked by first retrieving an API access token from Azure AD 
            // (using the ID token just received) and then verify if TenantInfo is present for this tenant. 
            // These actions are all performed automatically in the AuthorizationProvider component.
            return <Container><Spinner/></Container> 
        }

        if (this.props.authorizationContext.authorizationState === authorizationStates.UNAUTHORIZED) {
            console.log("[PostLogin] User is unauthorized, redirecting to 'unauthorized' page.");
            // The authorization is finished and this user is not authorized to use this application.
            return <Redirect to='/unauthorized'/>
        }

        // The authorization is finished and the tenant is authorized to use this application.
        console.log("[PostLogin] Normal login, redirecting to 'portal'.");

        if (this.props.tenantContext.isLoading) {
            return <Container><Spinner/></Container>;
        }

        const postRedirectUrl = sessionStorage.getItem('postRedirectUrlKey');

        if (postRedirectUrl) {
            return <Redirect to={postRedirectUrl}/>;
        }

        return <Redirect to='/portal/license-overview'/>;
    }
}

export const PostLogin = (props) => {
    const authenticationContext = useContext(AuthenticationContext);
    const authorizationContext = useContext(AuthorizationContext);
    const tenantContext = useContext(TenantContext);
  
    return (
        <PostLoginInternal 
            authenticationContext={authenticationContext} 
            authorizationContext={authorizationContext}
            tenantContext={tenantContext} 
            {...props}
        />
    )
}